import { observer } from 'mobx-react'
import React from 'react'
import {
   AIChatUIStoreProvider,
   ChatConfigStoreProvider
} from '@flowwai-frontend/shared-web/ai-chat-support/data-access'
import { AIChatSupportContext } from '@flowwai-frontend/shared-web/ai-chat-support/ui'

import AIChatBoxController from '../../controllers/AIChatBoxController/AIChatBoxController'

interface Props {
   onClose: () => void
}

const AIChatSupportRoute = (props: Props): React.ReactElement => (
   <ChatConfigStoreProvider>
      <AIChatUIStoreProvider>
         <AIChatSupportContext.Provider value={{ onCloseChat: props.onClose }}>
            <AIChatBoxController {...props} />
         </AIChatSupportContext.Provider>
      </AIChatUIStoreProvider>
   </ChatConfigStoreProvider>
)

export default observer(AIChatSupportRoute)
